export function UnknownException () {
  return new Error('Wystąpił nieoczekiwany błąd.')
}

UnknownException.prototype = Object.create(Error.prototype)
